import * as z from "zod/v4";

export const adminSendMobileMessageReply = {
  name: "adminSendMobileMessageReply" as const,
  input: z.object({
    teamId: z.string(),
    conversationId: z.string(),
    message: z.string().min(1).max(1600),
  }),
  output: z.object({ success: z.boolean() }),
};
